import App from './App.svelte';

var app = new App({
	target: document.getElementsByClassName('app')[0]
});

export default app;